import { features } from "@/mocks/home";

export default function FocusSection() {
  return (
    <section id="focus" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-book-open-line"></i>深读专题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              不止吃瓜，也聊门道
            </h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              深读热点背后的行业逻辑与完整时间线，为实时动态提供更扎实的来龙去脉。
            </p>
          </div>
          <a
            href="#subscribe"
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-semibold text-foreground-700 transition hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
          >
            更多专题 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {features.map((f) => (
            <article
              key={f.title}
              className="group relative min-h-[380px] w-full overflow-hidden rounded-xl"
            >
              <img
                src={f.img}
                alt={f.title}
                className="absolute inset-0 h-full w-full object-cover transition duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/5"></div>
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                <span className="whitespace-nowrap rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                  {f.cat}
                </span>
                <h3 className="mt-3 max-w-xl font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
                  {f.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-accent-300">
                  阅读全文 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}